import { platformToast } from "$root/notification-system/toast";
import { CUSTOM_ATTRIBUTE_MAX_DECIMAL_PLACES } from "./decimalCap";

/**
 * Tells the user how many values a paste or fill refused for having too many decimals.
 *
 * The grid sets every pasted or filled cell within one task, so the refusals counted until the next one
 * belong to the same operation and raise a single toast.
 */
export function createRefusedDecimalsNotice(): () => void {
	let refused = 0;
	return () => {
		refused += 1;
		if (refused > 1) {
			return;
		}
		setTimeout(() => {
			const count = refused;
			refused = 0;
			platformToast({
				severity: "warning",
				icon: "Portfolio",
				children: `${count} ${count === 1 ? "value has" : "values have"} more than ${CUSTOM_ATTRIBUTE_MAX_DECIMAL_PLACES} decimals and ${count === 1 ? "was" : "were"} skipped`,
			});
		});
	};
}
